import React, { useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import AppCheckBox from "@/features/line-sheet-sets/app-checkbox";
import usePutOrderSheetSetUpdateStatus from "@/features/my-order/features/order-history/features/final-copy/hooks/query/usePutOrderSheetSetUpdateStatus";
import useOrderHistoryDetail from "@/features/my-order/features/order-history/hooks/useOrderHistoryDetail";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

function OrderHistoryFinalCopyApproveModal({ isOpen, onClose }: Props) {
  const [isApproveChecked, setIsApproveChecked] = useState(false);
  const { orderSheetSetId } = useOrderHistoryDetail();
  const { updateStatus, isPending } = usePutOrderSheetSetUpdateStatus(
    orderSheetSetId ? +orderSheetSetId : 0
  );

  const handleApproveFinalVersion = async () => {
    if (!orderSheetSetId) return;
    updateStatus({
      order_sheet_set_ids: [+orderSheetSetId],
      status: "BUYER_CONFIRMED",
    });
    handleClose();
  };

  const handleClose = () => {
    setIsApproveChecked(false);
    onClose();
  };

  return (
    <CustomApprovalModal isOpen={isOpen} onClose={handleClose}>
      <CustomApprovalModal.Header
        title="확정본을 승인하시겠습니까?"
        onClose={handleClose}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"16px"}>
          <Text textStyle={"body-sm-regular"} color={"#6F6F6C"}>
            모델명, 색상, 사이즈 등 확정본의 모든 항목을 꼼꼼히 확인해 주세요.
            <br />
            승인 후에는 프로포르마가 발행되어, 취소 및 변경이 불가능합니다.
          </Text>
          <Flex
            alignItems={"center"}
            textStyle={"body-sm-regular"}
            color={"#444444"}
          >
            <AppCheckBox
              name={"위 내용을 확인하였으며, 오더 확정에 동의합니다."}
              isChecked={isApproveChecked}
              onChange={(checked) => setIsApproveChecked(checked)}
            />
            <Text color={"#CC1D1D"}>*</Text>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        onCancel={handleClose}
        onConfirm={handleApproveFinalVersion}
        confirmName="승인"
        isLoading={isPending}
        isConfirmDisabled={!isApproveChecked}
      />
    </CustomApprovalModal>
  );
}

export default OrderHistoryFinalCopyApproveModal;
